import React from 'react';
import styles from './Button.module.css';

const Button = ({ children, onClick, variant = 'primary', size = 'large' }) => {
  return (
    <button
      className={`${styles.button} ${styles[variant]} ${styles[size]}`}
      onClick={onClick}
    >
      {children}
    </button>
  );
};

export default Button;




